// Delegated listener on the document, like jQuery's $(document).on(type, selector, handler): works for elements
// added later (modal content, cards loaded by infinite scroll). The handler gets the event and the matched element
export function on(type, selector, handler) {
    document.addEventListener(type, function (e) {
        const el = e.target.closest?.(selector);
        if (el) handler(e, el);
    });
}
